import { c as _c } from "react/compiler-runtime";
import { IcoArrowTopRight16 } from '@onefootprint/icons';
import type { AuditEventDetail } from '@onefootprint/request-types/dashboard';
import { LinkButton } from '@onefootprint/ui';
import capitalize from 'lodash/capitalize';
import { useTranslation } from 'react-i18next';
type ManuallyReviewEntityProps = {
  detail: AuditEventDetail;
  hasPrincipalActor: boolean;
};
const ManuallyReviewEntity = t0 => {
  const $ = _c(26);
  const {
    detail,
    hasPrincipalActor
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "events.manualReview"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("security-logs", t1);
  if (detail.kind !== "manually_review_entity") {
    return null;
  }
  const {
    decisionStatus,
    fpId,
    kind
  } = detail.data;
  const url = kind === "person" ? `/users/${fpId}` : `/businesses/${fpId}`;
  let t2;
  if ($[1] !== hasPrincipalActor || $[2] !== t) {
    t2 = hasPrincipalActor ? t(_temp) : capitalize(t(_temp2));
    $[1] = hasPrincipalActor;
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <span className="text-body-2 text-tertiary">{t2}</span>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t) {
    t4 = t(_temp3);
    $[6] = t;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t4) {
    t5 = <span className="text-body-2 text-tertiary">{t4}</span>;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== kind || $[11] !== t) {
    t6 = kind === "person" ? t(_temp4) : t(_temp5);
    $[10] = kind;
    $[11] = t;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t6 || $[14] !== url) {
    t7 = <LinkButton href={url} target="_blank" iconComponent={IcoArrowTopRight16}>{t6}</LinkButton>;
    $[13] = t6;
    $[14] = url;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== decisionStatus || $[17] !== t) {
    t8 = t(_temp6, {
      status: decisionStatus
    });
    $[16] = decisionStatus;
    $[17] = t;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== t8) {
    t9 = <span className="text-body-2 text-tertiary">{t8}.</span>;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== t3 || $[22] !== t5 || $[23] !== t7 || $[24] !== t9) {
    t10 = <>{t3}{t5}{t7}{t9}</>;
    $[21] = t3;
    $[22] = t5;
    $[23] = t7;
    $[24] = t9;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  return t10;
};
export default ManuallyReviewEntity;
function _temp($) {
  return $.manuallyReviewedAnd;
}
function _temp2($_0) {
  return $_0.manuallyReviewedAnd;
}
function _temp3($_1) {
  return $_1.markedA;
}
function _temp4($_2) {
  return $_2.user;
}
function _temp5($_3) {
  return $_3.business;
}
function _temp6($_4) {
  return $_4.as;
}